export default {
  // Page title
  'adsMccAccount.title': 'Configuración de cuenta MCC',

  // Search fields
  'adsMccAccount.platform': 'Plataforma de anuncios',
  'adsMccAccount.mccName': 'Nombre MCC',

  // Buttons
  'adsMccAccount.search': 'Buscar',
  'adsMccAccount.reset': 'Restablecer',
  'adsMccAccount.add': 'Añadir',
  'adsMccAccount.delete': 'Eliminar',

  // Table columns
  'adsMccAccount.serial': 'Serie',
  'adsMccAccount.apiToken': 'Token de API del desarrollador',
  'adsMccAccount.clientId': 'ID de cliente OAuth',
  'adsMccAccount.clientSecret': 'Secreto de cliente OAuth',
  'adsMccAccount.refreshToken': 'Token de actualización',
  'adsMccAccount.authStatus': 'Estado de autenticación',
  'adsMccAccount.action': 'Acción',

  // Auth status
  'adsMccAccount.authorized': 'Autorizado',
  'adsMccAccount.unauthorized': 'No autorizado',

  // Form validation
  'adsMccAccount.platformRequired': 'Por favor seleccione la plataforma de anuncios',
  'adsMccAccount.mccNameRequired': 'Por favor ingrese el nombre MCC',
  'adsMccAccount.refreshTokenRequired': 'Por favor ingrese el token de actualización',

  // Form placeholders
  'adsMccAccount.mccNamePlaceholder': 'Nombre MCC personalizado',
  'adsMccAccount.apiTokenRequired': 'Por favor ingrese el token de API del desarrollador',
  'adsMccAccount.clientIdRequired': 'Por favor ingrese el ID de cliente OAuth',
  'adsMccAccount.clientSecretRequired': 'Por favor ingrese el secreto de cliente OAuth',
  'adsMccAccount.refreshTokenPlaceholder': 'Por favor haga clic en el botón a continuación para obtener',
  'adsMccAccount.getRefreshToken': 'Obtener token de actualización',
  'adsMccAccount.getRefreshTokenInfo': 'Obteniendo token de actualización...',
  'adsMccAccount.validationError': 'Por favor complete todos los campos requeridos',
  'adsMccAccount.save': 'Guardar',
  'adsMccAccount.cancel': 'Cancelar',
  'adsMccAccount.fetchDataFailed': 'Error al obtener datos',
  'adsMccAccount.fetchTypesFailed': 'Error al obtener tipos de plataforma de anuncios',
  'adsMccAccount.noData': 'Sin datos',

  // Modal title
  'adsMccAccount.addMccAccount': 'Añadir cuenta MCC',

  // Messages
  'adsMccAccount.addSuccess': 'Añadido exitosamente',
  'adsMccAccount.addFailed': 'Error al añadir',
  'adsMccAccount.deleteSuccess': 'Eliminado exitosamente',
  'adsMccAccount.deleteFailed': 'Error al eliminar',
  'adsMccAccount.confirmDelete': '¿Seguro que desea eliminar este registro?',

  // Pagination
  'adsMccAccount.totalRecords': 'Total {total} registros',
  'adsMccAccount.pagination': 'Página {current} de {page}, Total {total} registros',
};
